import { getEnvironmentAtRunTime } from '@cash-web/shared-util-environment'

export function getHeadersForWebAuthn() {
  // The X-Override-RP-ID header is needed in development because without it the server will reject the requests
  // because of a rp.id and domain mismatch
  if (getEnvironmentAtRunTime() === 'development') {
    return {
      'X-Override-RP-ID': 'localhost',
    }
  }

  return undefined
}
